export default "__VITE_ASSET__D61FIfC9__"